<!--
 * @Auther: 罗耀祖
 * @Date: 2021-07-07 17:27:53
 * @LastEditors: 罗耀祖
 * @LastEditTime: 2021-07-23 13:47:49
 * @name: 延期审批流
 * @Description: 延期审批流
 * @FilePath: \backstage\src\views\approvalManage\delayApprovalManage.vue
 * @Author: DESKTOP-1QU67QM
-->
<template>
  <div>
    
  </div>
</template>
<script>

export default {
  name: "delayApprovalManage",
  components: {
    
  },
  data() {
    return {
      
    };
  },
  methods: {
    
  },
};
</script>
<style lang="scss" scoped>

</style>